import { Message, H5, P } from "@adfenix/alexandria";
import * as DOMPurify from "dompurify";

const ErrorMessageWithTitle = ({
  title,
  body
}: {
  title: string | undefined;
  body: string | undefined;
}) => {
  return title || body ? (
    <Message type="error">
      {title && <H5>{title}</H5>}
      {body && title ? (
        <P
          style={{ fontWeight: "normal" }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(body)
          }}
        ></P>
      ) : (
        body
      )}
    </Message>
  ) : (
    <></>
  );
};

export default ErrorMessageWithTitle;
